// extracted by mini-css-extract-plugin
export var boxItems = "_88-1";
export var button = "_88-5";
export var filterGroupBox = "_88-0";
export var icon = "_88-2";
export var iconSecondary = "_88-4";
export var iconWrapper = "_88-3";